module.exports = __webpack_public_path__ + "static/media/closeIcon.d8e7d545.svg";